import { render, staticRenderFns } from "./page.vue?vue&type=template&id=559b60e4&scoped=true&"
var script = {}
import style0 from "./page.vue?vue&type=style&index=0&id=559b60e4&lang=scss&scoped=true&"
import style1 from "./page.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559b60e4",
  null
  
)

export default component.exports